import { jsx as _jsx } from "react/jsx-runtime";
import { queryClient } from '@as-react/common-queries';
import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
export const WrapWithQueryContext = (BaseComponent, { dehydratedState }) => function QueryContextWrapper(props) {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(HydrationBoundary, { state: dehydratedState, children: _jsx(BaseComponent, { ...props }) }) }));
};
